import React, { useEffect, useMemo, useState } from "react";
import {Avatar,Box,Button,Card,CardContent,CircularProgress,Grid,IconButton,List,ListItem,Checkbox,  
  ListItemText,MenuItem,Paper,Stack,Table,TableBody,TableCell,TableContainer,TableHead,TableRow,ListItemButton,
  TextField,Typography,Chip,Alert,Dialog,DialogTitle,DialogContent,DialogActions,Divider, Collapse, Switch } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ListItemIcon from '@mui/material/ListItemIcon';
import EditIcon from "@mui/icons-material/Edit";
import PersonIcon from "@mui/icons-material/Person";
import PeopleIcon from "@mui/icons-material/People";
import DescriptionIcon from "@mui/icons-material/DescriptionOutlined";
import ArrowBack from "@mui/icons-material/ArrowBack";
import Logout from "@mui/icons-material/Logout";
import AccessTime from "@mui/icons-material/AccessTime";
import SendIcon from "@mui/icons-material/Send";
import AddIcon from "@mui/icons-material/Add";
import Loop from '@mui/icons-material/Loop';
import ManageAccounts from '@mui/icons-material/ManageAccounts';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import AttachFileIcon from "@mui/icons-material/AttachFile";
import GroupAdd from "@mui/icons-material/GroupAdd";
import PersonRemove from "@mui/icons-material/PersonRemove";
import SortIcon from '@mui/icons-material/Sort';
import FilterListIcon from '@mui/icons-material/FilterList';
import ImportExportOutlined from '@mui/icons-material/ImportExportOutlined';
import useFirestoreData, { auth, realtimeDb, db, UtenteDB, inviaInvito, caricaFileCliente, eliminaFile, aggiornaStatoFileCliente, 
  completaProfilo, useClientFiles, addErrorLog, ChangeOneVariable, condividiCliente, rimuoviCondivisioneCliente, initialOptions, OptionsState } from "./FirestoreDataLoader.tsx";
import { countUsersFromFirestore, sommaFileCaricati, DatiTotUtenti, DatiUtenteSemplificati, useFileElaboratiCount, useFileInviatiCount, useAllClientFileCounts } from "./aggregatiFirebaseCollection.tsx";
import { useNavigate } from 'react-router-dom';
import { Download, AlertTriangle , Trash2Icon } from "lucide-react";
import { ShowLogout } from './Logout.tsx';
import { FormWithEntry, FormProfiloData } from './ProfiloUtente.tsx';
import { useFileContext } from "./arrayFileContext.tsx";
import { useConfirmToast } from "./alertFunction.tsx";
import { useSendInvite } from "./templateEmail.tsx";
import { onAuthStateChanged } from "firebase/auth";
import { applyAllFilters, FilterDialog } from "./filterArray.tsx";
import { ref as databaseRef, onDisconnect, update, onValue } from "firebase/database";


type StatCardProps = {
  icon?: React.ReactNode;
  title: string;
  value: string | number;
  subtitle?: string;
};


// tipo di tutte le chiavi valide
type OptionKey = keyof OptionsState;

// Tipizzazione delle etichette
const optionLabels = {
  originalNumero_fattura : 'Mantieni Numero Fattura originale (anche con caratteri speciali)',
  originalIndirizzo_P: "Mantieni Indirizzo Fornitore originale (anche se > 30 caratteri)",
  originalCAP_P: 'Mantieni CAP Fornitore originale',
  originalComune_P: 'Mantieni Comune Fornitore originale',
  originalIdPaese_T: 'Mantieni Paese Trasmittente originale', 
  originalIdCodice_T: 'Mantieni Codice Trasmittente originale',
  originalIdPaese_P: 'Mantieni Paese Fornitore originale',
  originalIdCodice_P: 'Mantieni Codice Fornitore originale',
  //originalIdPaese_C: string,
};
 

//  StatisticaCard 
const StatisticaCard: React.FC<StatCardProps> = ({ icon, title, value, subtitle }) => {
  return (
    <Card variant="outlined" sx={{ minWidth: 180 }}>
      <CardContent>
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar sx={{ bgcolor: '#1b7edbff', width: 48, height: 48 }}>{icon}</Avatar>
          <Box>
            <Typography variant="subtitle2" color="textSecondary">
              {title}
            </Typography>
            <Typography variant="h5">{value}</Typography>
            {subtitle && (
              <Typography variant="caption" color="textSecondary">
                {subtitle}
              </Typography>
            )}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

//  Helper per color/status
const statoChipPropsStatoI = (stato: string) => {
  switch (stato) {
    case "Scaricato":
      return { label: "Scaricato", color: "secondary" as const };
    case "Elaborato":
      return { label: "Elaborato", color: "success" as const };
    case "Elaborazione in corso":
      return { label: "Elaborazione in corso", color: "warning" as const };
    case "Inviato":
      return { label: "Inviato", color: "primary" as const };
    case 'Registrato':
      return { label: 'Registrato', color:'success' as const };
    case 'in attesa':
      return { label:'In attesa', color: "warning" as const };
    case 'Nuovo Utente':
       return { label: 'Nuovo Utente', color: "secondary" as const };
    default:
      return { label: stato, color: "default" as const };
  }
};

const statoChipPropsTipoAcc = (stato: string) => {
  switch (stato) {
    case "amministratore":
      return { label: "Amministratore", color: "primary" as const };
    case "azienda":
      return { label: "Azienda", color: "success" as const };
    case "collaboratore":
      return { label: "Collaboratore", color: "warning" as const };
    case "cliente":
      return { label: "Cliente", color: "secondary" as const };
    default:
      return { label: stato, color: "default" as const };
  }
};

const formatTime = (totalSeconds: number): string => {
    if (totalSeconds === 0) {
        return "0 s";
    }
    // Costanti 
    const SECONDS_IN_MINUTE = 60;
    const SECONDS_IN_HOUR = 3600;

    // inferiore a 60 secondi, secondi
    if (totalSeconds < SECONDS_IN_MINUTE) {
        return `${Math.round(totalSeconds)} s`;
    }
    
    // inferiore a 1 ora, minuti 
    if (totalSeconds < SECONDS_IN_HOUR) {
        const minutes = totalSeconds / SECONDS_IN_MINUTE;
        return `${minutes.toFixed(1)} m`;
    }

    // Altrimenti, mostra ore
    const hours = totalSeconds / SECONDS_IN_HOUR;
    return `${hours.toFixed(1)} h`;
};


// --- Funzioni di ordinamento---

// Funzione helper per ottenere il valore annidato (se esiste)
function getNestedValue(obj: any, path: string) {
    return path.split('.').reduce((acc, part) => (acc && acc[part] !== undefined) ? acc[part] : null, obj);
}

// Funzione di utilità per convertire la tua stringa data/ora in un oggetto Date
function convertDateString(dateString:string) {
    if (!dateString) return new Date(0); // Gestisci valori vuoti
    
    const [datePart, timePart] = dateString.split(', ');
    const [day, month, year] = datePart.split('/').map(Number);
    const [hour, minute, second] = timePart ? timePart.split(':').map(Number) : [0, 0, 0];

    // Crea l'oggetto Date in modo robusto (Mese è 0-indicizzato in JS: month - 1)
    return new Date(year, month - 1, day, hour, minute, second);
}

// Funzione per confrontare due elementi in base a un campo e una direzione.
function descendingComparator(a:any, b:any, orderBy:string) {

  if (orderBy === 'xml_completati_count' || orderBy === 'pdf_scaricabili_count' || orderBy === 'file_caricati_count') {
        const aValue = a[orderBy] ?? 0; // Assicura che sia un numero, usa 0 come fallback
        const bValue = b[orderBy] ?? 0;

        if (bValue < aValue) {
            return -1;
        }
        if (bValue > aValue) {
            return 1;
        }
        return 0; // Se i valori sono uguali
    }

  // Usa la funzione getNestedValue per recuperare il valore, supportando campi di primo livello e annidati.
  if(orderBy.includes('.')){
    const aValue = getNestedValue(a, orderBy);
    const bValue = getNestedValue(b, orderBy);
    if (bValue === null || bValue === undefined) return (aValue === null || aValue === undefined) ? 0 : -1; 
    if (aValue === null || aValue === undefined) return 1;

    if (bValue < aValue) {
      return -1;
    }
    if (bValue > aValue) {
      return 1;
    }
    return 0;
  }

  // Gestione speciale per le date
  if (orderBy === 'data_registrazione') {
    // Converti le stringhe data (DD/MM/YYYY, HH:mm:ss) in oggetti Date per un confronto corretto
    const dateA = convertDateString(a[orderBy]);
    const dateB = convertDateString(b[orderBy]);

    if (dateB < dateA) {
      return -1;
    }
    if (dateB > dateA) {
      return 1;
    }
    return 0;
  }
  
  // Gestione speciale per 'Ultima Attività' se è 'online' o una data
  if (orderBy === 'ultimoAccessoTimestamp') {
        const ONLINE_VALUE = Number.MAX_SAFE_INTEGER; 

        const valueA = a[orderBy] === 'online'
            ? ONLINE_VALUE
            : convertDateString(a[orderBy]).getTime(); 

        const valueB = b[orderBy] === 'online'
            ? ONLINE_VALUE
            : convertDateString(b[orderBy]).getTime();

        if (valueB < valueA) return -1; 
        if (valueB > valueA) return 1;  
        return 0;
    }

  // Confronto standard per stringhe (email, tipo_account)
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order:string, orderBy:string) {
  return order === 'desc'
    ? (a:any, b:any) => descendingComparator(a, b, orderBy)
    : (a:any, b:any) => -descendingComparator(a, b, orderBy);
}

// Funzione che ordina l'array
function sortArray(array:any[], order:string, orderBy:string) {
  const comparator = getComparator(order, orderBy);
  
  // Mappa l'array per mantenere la stabilità dell'ordinamento, poi ordina
  const stabilizedThis = array.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1]; // Stabilità per l'indice originale
  });

  return stabilizedThis.map((el) => el[0]);
}

// componente principale
const DashboardApp: React.FC = () => {

  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [deliteFileModal, setDeliteFileModal] = useState(false);
  const [downloadModal, setDownloadModal] = useState(false);
  const [clienteUid, setClienteUid] = useState('');
  const navigate = useNavigate ();

  // dati dell'utente
  const { tipoAccount, email, userPhotoURL, ragioneSociale, partitaIva, indirizzo, cap, comune, nazione, userId, statisticheUtente, fileCliente,
    invitatoDaUID, aziende_invitate, collaboratori_invitati, clienti_invitati, inviti_emessi, clientiCollaboratori, OptionsState, isDataLoad } = useFirestoreData();
  
  const tA = localStorage.getItem('tipoAccount');
  
  //salviamo tipo_account per evitare il flickering 
    useEffect(() => {
      const saveTipoAccount = async () => {
        if (!tA){
          if (isDataLoad && tipoAccount){
            localStorage.setItem('tipoAccount', tipoAccount);
          }
        }
      };
      saveTipoAccount();
    }, [isDataLoad, tipoAccount]);
    
  const tipo_Account =  tA ? tA : tipoAccount ;

  const { errorAlert, successAlert, warningAlert } = useConfirmToast();
  const [loading, setLoading] = useState<boolean>(false);

  const [optionModal, setOptionModal] = useState(false);
  const [optionsState, setOptionsState] = useState<OptionsState>(initialOptions);
  
  // Sovrascrive lo stato iniziale con quello trovato in firebase
  useEffect(() => {
    if (!isDataLoad) return;

    try {
      if (OptionsState) {
        localStorage.setItem('userOptionsState', JSON.stringify(OptionsState));
        setOptionsState(OptionsState);
      }
    } catch (error) {
      console.error("Errore nel caricamento dei setting:", error);
    }
  }, [isDataLoad]);
  
  // gestisce i click sugli switc per i setting
  const handleToggleOption = (optionName: OptionKey) => async (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;

    // Aggiorna subito lo stato locale 
    setOptionsState(prev => {
      const updated = { ...prev, [optionName]: newValue };

      // Salva in localStorage
      localStorage.setItem('userOptionsState', JSON.stringify(updated));

      return updated;
    });

    // Aggiorna Firebase
    try {
      await ChangeOneVariable("OptionsState", {
        ...optionsState,
        [optionName]: newValue,
      });
    } catch (err) {
      console.error("Errore salvataggio Firebase:", err);
    }
  };


  // funzionalità Admin/Azienda condivisione dei clienti
  const [infoCilentiColl, setInfoCilentiColl] = useState(false);
  const [collaboratore, setCollaboratore] = useState('');
  const [emailcoll, setEmailcoll] = useState('');
  const [selectedClienti, setSelectedClienti] = useState<string[]>([]);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [selectedCollaboratori, setSelectedCollaboratori] = useState<string[]>([]);
  const [rimuoviCliente, setRimuoviCliente] = useState('');
  const [confermaRimozione, setConfermaRimozione] = useState(false);
  const [emailCli, setEmailCli] = useState('');

  // invia invito
  const { sendMail, sent } = useSendInvite();


  const toggleCliente = (uid: string) => {
    setSelectedClienti(prev =>
      prev.includes(uid)
        ? prev.filter(x => x !== uid)
        : [...prev, uid]
    );  
  };

  const toggleCollaboratore = (uid: string) => {
    setSelectedCollaboratori(prev =>
      prev.includes(uid)
        ? prev.filter(x => x !== uid)
        : [...prev, uid]
    );
  };

  const handleCondivisione = async () => {
    try {
      for (const collUID of selectedCollaboratori) {
        sendMail('clienteCondiviso', collUID, email)
        for (const clienteUID of selectedClienti) {
          await condividiCliente(clienteUID, collUID);
        }
      }

      successAlert("", "Clienti condivisi correttamente!");

      setSelectedCollaboratori([]);
      setSelectedClienti([]);
      setShareModalOpen(false);

    } catch (error:any) {
      console.error(error);
      errorAlert(error, "Errore durante la condivisione clienti");
    }
  };

const handleRimuoviCondivisione = async () => {
  try{
    await rimuoviCondivisioneCliente(rimuoviCliente, collaboratore);
    successAlert('', 'La condivisione è stata rimossa')
  } catch (error:any) {
    console.error(error);
    errorAlert(error, "Errore");
  }
}


  // selezione dei file pdf da scaricare
  const { files, isLoadingCF } = useClientFiles(clienteUid);
  const [elaboratiOpen, setElaboratiOpen] = React.useState(false);
  const [selectedFileNames, setSelectedFileNames] = useState<string[]>([]);
  const totalFiles = Object.keys(files.Inviato).length;
  const selectedCount = selectedFileNames.length;
  const selectAll = totalFiles > 0 && selectedCount === totalFiles;
  const indeterminate = selectedCount > 0 && selectedCount < totalFiles;

  // file selezionati per l'eliminazione
  const [filesToDelete, setFilesToDelete] = useState<string[]>([]);
  const totalClientFiles = fileCliente ? fileCliente.length : 0;
  const selectedDeleteCount = filesToDelete.length;
  const selectAllForDelete = totalClientFiles > 0 && selectedDeleteCount === totalClientFiles;
  const indeterminateForDelete = selectedDeleteCount > 0 && selectedDeleteCount < totalClientFiles;

  // Gestione della singola selezione di un file
  const handleToggle = (fileName:string) => {
    setSelectedFileNames(prevSelected => {
      const isCurrentlySelected = prevSelected.includes(fileName);
      if (isCurrentlySelected) {
        // Rimuovi
        return prevSelected.filter((name:any) => name !== fileName);
      } else {
        // Aggiungi 
        return [...prevSelected, fileName];
      }
    });
  };

  // singola selezione di un file
  const handleToggleElaborati = () => {
    setElaboratiOpen(!elaboratiOpen);
  };

  // singola selezione per eliminazione
  const handleToggleDelete = (fileName: string) => {
    setFilesToDelete(prevSelected => {
      const isCurrentlySelected = prevSelected.includes(fileName);
      if (isCurrentlySelected) {
        // Rimuovi
        return prevSelected.filter(name => name !== fileName);
      } else {
        // Aggiungi
        return [...prevSelected, fileName];
      }
    });
  };


  // selezione di tutti i file
  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const allFileNames = files.Inviato.map(file => file.nome);
      // Imposta l'array con tutti i nomi dei file estratti
      setSelectedFileNames(allFileNames);
    } else {
      // Deseleziona tutti
      setSelectedFileNames([]);
    }
  };

  // selezione di tutti i file per eliminazione
  const handleSelectAllDelete = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!fileCliente) return;

    if (event.target.checked) {
      const allFileNames = fileCliente.map(file => file.nome);
      // Imposta l'array con tutti i nomi dei file estratti
      setFilesToDelete(allFileNames);
    } else {
      // Deseleziona tutti
      setFilesToDelete([]);
    }
  };


  //chiudi modale di download/elaborazione
  const handleClose = () => {
    setDownloadModal(false);
    setClienteUid('');
    setSelectedFileNames([]); 
    setElaboratiOpen(false);
  };

  const recuperaBlobDaUrl = async (downloadURL: string, fileName: string): Promise<Blob> => {
    try {
        const response = await fetch(downloadURL);
        if (!response.ok) {
          addErrorLog(`Errore HTTP: ${response.status} - Impossibile scaricare il file.`, response);
          throw new Error(`Errore HTTP: ${response.status} - Impossibile scaricare il file.`);
        }

        // convertiamo in un oggetto Blob
        const blob = await response.blob();
        
        if (fileName) {
          // Creiamo l'oggetto File 
          const fileType = blob.type || 'application/pdf';
          return new File([blob], fileName, { type: fileType });
        }

        return blob;

    } catch (error) {
        addErrorLog("Si è verificato un errore durante il recupero del file.", error);
        throw new Error("Si è verificato un errore durante il recupero del file.");
    }
  };

  const startDownloadBlob = async (downloadURL: string, filename: string): Promise<void> => {
    try {
        const fileBlob = await recuperaBlobDaUrl(downloadURL, filename);
        const localUrl = URL.createObjectURL(fileBlob);

        // Simula il click sul link 
        const link = document.createElement('a');
        link.href = localUrl;
        link.setAttribute('download', filename);
        link.style.display = 'none';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Rilascia l'URL locale per liberare memoria
        URL.revokeObjectURL(localUrl);

    } catch (error) {
        addErrorLog(`Errore nel download del file ${filename}:`, error);
        throw new Error(`Errore nel download del file ${filename}`);
    }
  };

  //Funzione per recuperare il link di download
  const findFileByUrl = (fileName: string, categorizedFiles: any) => {
    let foundFile = categorizedFiles.Inviato.find((f:any) => f.nome === fileName);
    if (!foundFile) {
      foundFile = categorizedFiles.Elaborato.find((f:any) => f.nome === fileName);
    }
    return foundFile;
  };

  // Funzione per il download multiplo
  const handleMultipleDownload = async() => {
    if (selectedCount === 0) return;
    selectedFileNames.forEach(async (fileName) => {
      const fileToDownload = findFileByUrl(fileName, files);
      const downloadUrl = fileToDownload.url;
      startDownloadBlob(downloadUrl, fileName);
    });

    setTimeout(() => {
      handleClose();
    }, 500); 
  };

  // aggiungiamo i file selezionati al context 
  const { filesContext, setFilesContext } = useFileContext();

  const handleAddContexArray = async() =>{
    for (const fileName of selectedFileNames) {
      await aggiornaStatoFileCliente( clienteUid, fileName, String(userId), 'Elaborazione in corso');
    }
    sessionStorage.setItem("clienteUid", clienteUid);

    const filePromises = selectedFileNames.map(async (fileName) => {
      const fileToDownload = findFileByUrl(fileName, files);
      const downloadUrl = fileToDownload.url;
      const fileBlob = await recuperaBlobDaUrl(downloadUrl, fileName);
      
      const fileType = fileBlob.type || 'application/pdf';
      const fileObject = new File([fileBlob], fileName, { 
        type: fileType
      });

      return fileObject;
    });
    try {
      const newFilesArray = await Promise.all(filePromises);
      setFilesContext(newFilesArray);
    
    } catch (error:any) {
      addErrorLog("Errore nel recupero dei file:", error);
      errorAlert(error , "Errore nel recupero dei file:");
    }
  };

  useEffect(() => {
    if (filesContext && filesContext.length > 0) {
      navigate("/");
    }
    
  }, [filesContext, navigate]);


    useEffect(() => {
    
        if (!auth || !realtimeDb) return;
    
        const unsubAuth = onAuthStateChanged(auth, (user) => {
            if (user) {
                const userUid = user.uid;
                const databaseRefForPresence = databaseRef(realtimeDb, `presenza/${userUid}`);
                const connectedRef = databaseRef(realtimeDb, '.info/connected');
    
                const onDisconnectRef = onDisconnect(databaseRefForPresence);
    
                onDisconnectRef.update({
                    ultimoAccessoTimestamp: new Date().toISOString()
                }).catch(error => console.error("Errore nell'impostare onDisconnect:", error));
    
                const unsubConnected = onValue(connectedRef, (snap) => {
                    if (snap.val() === true) {
                        onDisconnectRef.cancel(); 
    
                        update(databaseRefForPresence, {
                            ultimoAccessoTimestamp: 'online'
                        }).catch(error => console.error("Errore nell'aggiornare a online:", error));
    
                        onDisconnectRef.update({
                            ultimoAccessoTimestamp: new Date().toISOString()
                        }).catch(error => console.error("Errore nel ristabilire onDisconnect:", error));
    
                    } else {}
                });
    
                const cleanupPresence = () => {
                    unsubConnected(); 
                    onDisconnectRef.cancel(); 
                };
    
                return cleanupPresence;
    
            } else {}
            
            return undefined; 
        });
    
        return () => unsubAuth();
    }, [auth, realtimeDb]);

  
  //utenti totali
  const [TotUtenti, setTotUtenti] = useState<number>(0);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const count = await countUsersFromFirestore();
        setTotUtenti(count);
      } catch (error) {
        setTotUtenti(0);
        console.error("Errore nel conteggio utenti:", error);
      }
    };
    fetchCount();
  }, []);


  // totale file
  const [totFile, setTotFile] = useState<number>(0);
  
  useEffect(() => {
    const fetchCount = async () => {
      try {
        const count = await sommaFileCaricati();
        setTotFile(count);
      } catch (error) {
        setTotFile(0);
        console.error("Errore nel conteggio utenti:", error);
      }
    };
    fetchCount();
  }, []);

  // otteniamo i dati di ogni singolo utente
  const [datiUtenti, setDatiUtenti] = useState<DatiUtenteSemplificati[] | []>([]);;

  useEffect(() => {
    //viene eseguita ad ogni aggiornamento dei dati
    const handleDatiAggiornati = (dati: DatiUtenteSemplificati[]) => {
      setDatiUtenti(dati);
    };
    try{
      const unsubscribe = DatiTotUtenti(db, handleDatiAggiornati);
      return () => {
        unsubscribe();
      };
    }catch(error:any){
      addErrorLog('Dati Utenti non aggiornati !', error);
      errorAlert(error,'Dati Utenti non aggiornati !');
    }
    
  }, []);


  // Stato di caricamento iniziale 
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // File caricati dal cliente
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

  // Modali
  const [editOpen, setEditOpen] = useState(false);
  const [inviteDialogOpen, setInviteDialogOpen] = useState(false);
  const [invitoEmail, setInvitoEmail] = useState("");
  const [invitoTipo, setInvitoTipo] = useState<"azienda" | "collaboratore" | "cliente">("collaboratore");
  const [addRecordOpen, setAddRecordOpen] = useState(false);


  useEffect(() => {
    if (userId) {
      setIsLoading(false);
    }
  }, [userId]);

  // Ruolo 
  const ruoloDisplay = useMemo(() => {
    switch (tipo_Account) {
      case "amministratore":
        return "Amministratore";
      case "azienda":
        return "Azienda";
      case "collaboratore":
        return "Collaboratore";
      case "cliente":
        return "Cliente";
      default:
        return `Ruolo: ${tipo_Account || "Non definito"}`;
    }
  }, [tipo_Account]);

  
  const handleInviaInvito = async () => {
    try {
      if (!invitoEmail) warningAlert("Inserisci un'email valida.");
     
      sendMail(invitoTipo, invitoEmail, email, String(userId));
      if(sent){
        await inviaInvito(invitoEmail, invitoTipo);
        //setInviteDialogOpen(false);
        //setInvitoEmail("");
      }
    } catch (e: any) {
      addErrorLog("Errore invio invito:", e);
      errorAlert(e.message, "Errore invio invito");
    }
  };

  const handleAggiungiRecord = async () => {
    try {
      if (!selectedFiles.length) warningAlert("Seleziona almeno un PDF");
      await caricaFileCliente(selectedFiles);
      sendMail('nuovoFile', String(invitatoDaUID), email);
      setSelectedFiles([]);
      setAddRecordOpen(false);
    } catch (e: any) {
      addErrorLog("Errore caricamento file:", e);
      errorAlert(e.message, "Errore caricamento file");
    }
  };

  const handleEliminaRecord = async () => {

    if (filesToDelete.length === 0) return;
    try {
        // Elimina in parallelo tutti i file selezionati
        await eliminaFile(filesToDelete);

        // Messaggio di successo
        const message = filesToDelete.length > 1 
            ? `${filesToDelete.length} file eliminati con successo.`
            : `File ${filesToDelete[0]} eliminato con successo.`;

        successAlert("", message);
        
        setDeliteFileModal(false);
        setFilesToDelete([]); 
    } catch (e: any) {
        addErrorLog("Impossibile cancellare i file:", e);
        errorAlert(e, "Impossibile cancellare i file");
    }
  }
  

  const totaleFile = () =>{
    let i = 0;
    collaboratori_invitati.forEach(u =>{
      i = i + u.statistiche_utente.fileCaricati
    });
    i = i + statisticheUtente.fileCaricati;
    return i
  };

  const totaleFileTeam = totaleFile();

  const handleSubmit = async (datiForm: FormProfiloData) => {

    const { pIva, ragioneSociale, indirizzo, cap, comune, nazione, apiKey } = datiForm;
    setLoading(true);
    try {
      await completaProfilo(String(userId), {
        tipoAccount: tipo_Account,
        pIva: pIva,
        ragioneSociale: ragioneSociale,
        indirizzo: indirizzo,
        cap: cap,
        comune: comune,
        nazione: nazione
      });
    
    } catch (error: any) {
      errorAlert(error.message || "Errore durante la modifica.");
    } finally {
      setLoading(false);
      setEditOpen(false);
    }
  }


  // stati per filtro
  type FilterValue = string | number | [number, number] | string[] | boolean | null;
    interface FilterState {
      [columnId: string]: FilterValue;
    }
    const [filterDialogOpen, setFilterDialogOpen] = useState(false);
    const [currentFilters, setCurrentFilters] = useState<FilterState>({});

    const [tipofiltro, setTipofiltro] = useState('');

    const handleOpenFilterDialog = () => setFilterDialogOpen(true);
    const handleCloseFilterDialog = () => setFilterDialogOpen(false);

    // Funzione per applicare i filtri 
    const handleApplyFilters = (newFilters: FilterState) => {
        setCurrentFilters(newFilters);
        setFilterDialogOpen(false);
    };

    // Funzione per resettare i filtri
    const handleClearFilters = () => {
        setCurrentFilters({});
        //setFilterDialogOpen(false);
    };


  //stato per ordinamento
  const [order, setOrder] = useState('asc'); // 'asc' o 'desc'
  const [orderBy, setOrderBy] = useState('email');
  useEffect(() => {
    if(isDataLoad && tipo_Account == 'amministratore'){
      setOrderBy('tipo_account')
    }
  },[isDataLoad])

  // Funzione helper per l'ordinamento utenti totali
  const sortedUsers = useMemo(() => {
    if (tipofiltro == 'amministratore' || tipofiltro == ''){
      const users = [...datiUtenti];
      let filteredUsers = users || [];
        filteredUsers = applyAllFilters(filteredUsers, currentFilters);
    
      return sortArray(filteredUsers, order, orderBy); 
    } else {
      const users = [...datiUtenti];
       return sortArray(users, order, orderBy);
    }
  }, [datiUtenti, tipofiltro, currentFilters, order, orderBy]);


  const handleRequestSort = (property:string) => {
    // Se è la stessa colonna, inverti l'ordine
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const [aziendeOrder, setAziendeOrder] = useState<'asc' | 'desc'>('asc');
  const [aziendeOrderBy, setAziendeOrderBy] = useState<string>('email');
  const [collOrder, setCollOrder] = useState<'asc' | 'desc'>('asc');
  const [collOrderBy, setCollOrderBy] = useState<string>('email');
  const [clientiOrder, setClientiOrder] = useState<'asc' | 'desc'>('asc');
  const [clientiOrderBy, setClientiOrderBy] = useState<string>('email');

  const handleRequestInviteSort = (property: string, tipo: string) => {
    if (tipo=='azienda'){
      const isAsc = aziendeOrderBy === property && aziendeOrder === 'asc';
      setAziendeOrder(isAsc ? 'desc' : 'asc');
      setAziendeOrderBy(property);
    };
    if (tipo=='collaboratore'){
      const isAsc = collOrderBy === property && collOrder === 'asc';
      setCollOrder(isAsc ? 'desc' : 'asc');
      setCollOrderBy(property);
    };
    if (tipo=='cliente'){
      const isAsc = clientiOrderBy === property && clientiOrder === 'asc';
      setClientiOrder(isAsc ? 'desc' : 'asc');
      setClientiOrderBy(property);
    };
  };


  // Componenti : tabelle riutilizzabili

  const TabInvitatiAC = ({ tipo, map_invitati, order, orderBy, onRequestSort } : { tipo: string, map_invitati: UtenteDB[], order: 'asc' | 'desc', orderBy: string, onRequestSort: (property: string, tipo:string) => void }) => {
    const title = tipo == 'azienda'? 'Aziende invitate': 'Collaboratori invitati';
    const isCollaboratore = tipo === 'collaboratore';

    // intestazioni e  chiavi di ordinamento 
    const headers = [
      { label: 'Email', id: 'email', sortable: true },
      { label: 'Ultima Attività', id: 'statistiche_utente.ultimoAccessoTimestamp', sortable: true },
      // Notazione per campi annidati
      { label: 'Statistiche Uso', id: 'statistiche_utente.fileCaricati', sortable: true }, 
      ...(isCollaboratore ? [{ label: 'Clienti', id: 'clienti_condivisi_count', sortable: true }] : []),
      { label: 'Stato Invito', id: 'statoInvito', sortable: false },
    ];
    
    // Funzione per l'handler di ordinamento
    const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(property, tipo);
    };

    // Preparazione dei Dati
    const activeUsersArray = Object.values(map_invitati || {}).map((user: any) => ({
      ...user,
      // Aggiungi la chiave di conteggio per l'ordinamento
      clienti_condivisi_count: isCollaboratore ? (clientiCollaboratori[user.uid] ? clientiCollaboratori[user.uid].length : 0) : null,
    }));
    
    const pendingInvites = Object.entries(inviti_emessi || {})
      .filter(([k, v]) => v.tipo === tipo)
      .map(([k, v]) => ({
        uid: `invite-${k}`, 
        email: v.email,
        statoInvito: v.stato,
        statistiche_utente: { ultimoAccessoTimestamp: null, fileCaricati: 0, tempoUtilizzoSecondi: 0 },
        clienti_condivisi_count: 0, 
      }));
      
    const combinedArray = [...activeUsersArray, ...pendingInvites];

    // Applicare l'Ordinamento 
    const sortedInvitedUsers = useMemo(() => {
      if (tipofiltro == tipo || tipofiltro == ''){
        let filteredUsers = combinedArray || [];
        filteredUsers = applyAllFilters(filteredUsers, currentFilters);
          return sortArray(filteredUsers, order, orderBy);
      } else {
        return sortArray(combinedArray, order, orderBy);
      }
    }, [combinedArray, tipofiltro, currentFilters, order, orderBy]);

    return(
      <div>
        <Typography variant="h6" sx={{marginBottom:'1rem'}}> 
          {title} 
          {Object.keys(currentFilters).length > 0 ? (
            tipofiltro == tipo?
            <IconButton   
              onClick={handleClearFilters}
              sx={{ml:'10px', width:'1.7rem', height:'1.7rem'}} 
              title="Rimuovi Filtro"
              color="primary" 
            >
             <SortIcon sx={{ width:'1.3rem', height:'1.3rem'}}/>
            </IconButton>
            :
            <IconButton   
              onClick={()=>{setTipofiltro(tipo); handleClearFilters(); handleOpenFilterDialog()}}
              sx={{ml:'10px', width:'1.7rem', height:'1.7rem'}} 
              title="Filtra"
              color="default"
            >
             <FilterListIcon sx={{ width:'1.3rem', height:'1.3rem'}}/>
            </IconButton>
          ):(
            <IconButton   
              onClick={()=>{setTipofiltro(tipo); handleOpenFilterDialog()}}
              sx={{ml:'10px', width:'1.7rem', height:'1.7rem'}} 
              title="Filtra"
              color="default"
            >
             <FilterListIcon sx={{ width:'1.3rem', height:'1.3rem'}}/>
            </IconButton>
          )}
        </Typography>
        <TableContainer component={Paper}  sx={{ maxHeight: '25rem' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {headers.map((head) => (
                  <TableCell
                    key={head.id}
                    sortDirection={orderBy === head.id ? order : false}
                    sx={{ cursor: head.sortable ? 'pointer' : 'default' }} 
                    onClick={head.sortable ? createSortHandler(head.id) : undefined}
                  >
                    <Stack direction="row" spacing={0} alignItems="center">
                      <Typography variant="body2" component="span">
                        {head.label}
                      </Typography>
                      {head.sortable && (
                        <IconButton
                          size="small"
                          title={order === 'asc' ? `Ordine Decrescente` : `Ordine Crescente`}
                          sx={{ 
                            ml: '5px',
                            padding: 0.5,  
                            width:'1.7rem'
                          }}
                        >
                          <ImportExportOutlined sx={{height:'1.2rem'}}/>
                        </IconButton>
                      )}
                    </Stack>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
             {(() => {
                const invitedRows:any = [];

                // Righe Inviti in Sospeso
                if (inviti_emessi) {
                    Object.entries(inviti_emessi).forEach(([k, v]) => {
                        if (v.tipo === tipo) {
                            invitedRows.push(
                                <TableRow key={`invite-${k}`}>
                                    <TableCell sx={{ padding: '0px 16px' }}>
                                        <div style={{ display:'flex', flexDirection:'row', alignItems: 'center', height: '100%', minHeight: '42px' }}>
                                            {v.email}
                                        </div>
                                    </TableCell>
                                    <TableCell>—</TableCell>
                                    <TableCell>—</TableCell>
                                    { tipo == 'collaboratore'? <TableCell>—</TableCell> : <></>}
                                    <TableCell>{v.stato ? <Chip {...statoChipPropsStatoI(v.stato)} /> : "—"}</TableCell>
                                </TableRow>
                            );
                        }
                    });
                }

                // Righe Aziende Attive
                if (sortedInvitedUsers) {
                   sortedInvitedUsers.map((v: any) => {
                        invitedRows.push(
                            <TableRow key={`active-${v.uid}`}>
                                <TableCell sx={{ padding: '0px 16px' }}>
                                    <div style={{ display:'flex', flexDirection:'row', alignItems: 'center', height: '100%', minHeight: '30px' }}>
                                        <Avatar 
                                            src={v.userPhotoURL || ""} 
                                            sx={{ maxWidth: '30px', maxHeight: '30px', marginRight: '0.7rem' }}
                                        /> 
                                        {v.email}
                                    </div>
                                </TableCell>
                                <TableCell>
                                    {v.statistiche_utente?.ultimoAccessoTimestamp === 'online'
                                        ? (
                                            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                                <div style={{ display: 'flex', backgroundColor: 'green', borderRadius: '50%', width: '20px', height: '20px', marginRight: '6px' }} /> 
                                                online
                                            </div>
                                        )
                                        : (
                                            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                                <div style={{ display: 'flex', backgroundColor: '#cf2020ff', borderRadius: '50%', width: '20px', height: '20px', marginRight: '6px' }} />
                                                {v.statistiche_utente?.ultimoAccessoTimestamp ? (new Date(v.statistiche_utente.ultimoAccessoTimestamp).toLocaleString()).slice(0, 17) : 'Invalid Date'}
                                            </div>
                                        )
                                    }
                                </TableCell>
                                <TableCell>
                                    File: {v.statistiche_utente?.fileCaricati ?? 0}
                                    {` — Tempo: ${formatTime(v.statistiche_utente?.tempoUtilizzoSecondi ?? 0)}`}
                                </TableCell>
                                { tipo == 'collaboratore'? 
                                  <TableCell>
                                    <IconButton 
                                      title='Visualizza lista clienti'
                                      onClick={()=> {setInfoCilentiColl(true); setCollaboratore(v.uid), setEmailcoll(v.email)}}
                                      sx ={{display:'flex', fontSize:18, minWidth:'30px', height:'30px', color:'#363738ff', boxShadow: '2', alignItems:"center", justifyContent:'center'}}
                                    >
                                      {clientiCollaboratori[v.uid] ? (clientiCollaboratori[v.uid]).length : 0}
                                    </IconButton>
                                  </TableCell> 
                                  : <></>
                                }
                                <TableCell>{v.statoInvito ? <Chip {...statoChipPropsStatoI(v.statoInvito)} /> : "—"}</TableCell>
                            </TableRow>
                        );
                    });
                }
                if (!invitedRows || invitedRows.length === 0) {
                    return (
                        <TableRow>
                            <TableCell colSpan={tipo == 'collaboratore'? 5 : 4} sx={{ textAlign: 'center', fontSize: '17px', color:'gray', minHeight: '42px' }}>
                                Nessun account {tipo} invitato.
                            </TableCell>
                        </TableRow>
                    );
                }
                return invitedRows;

            })()}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  }


  const FileElaboratiCell = ({ uidCliente } : { uidCliente: string }) => {
    const { count, isLoading } = useFileElaboratiCount(uidCliente);
    return (
      <TableCell>
        {isLoading
          ? "..."
            : count !== null
              ? count
              : 'Errore'
        }
      </TableCell>
    );
  };

  const FileInviatiCell = ({ uidCliente } : { uidCliente: string }) => {
    const { count, isLoading } = useFileInviatiCount(uidCliente);
    return (
      <TableCell>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', height: '100%', paddingRight:16 }}>
          <IconButton
            title='Scarica PDF'
            onClick={() => { setDownloadModal(true); setClienteUid(uidCliente) }}
            sx={{ width:'35px', height:'35px', color: 'green', marginRight: 1, boxShadow:'2'}}
          >
            <Download /> 
          </IconButton>
          <div> {isLoading ? "..." : count !== null ? count : 'Errore'} file da<br/>elaborare</div>
        </div>
      </TableCell>
    );
  };

  const TabInvitatiClienti = ({ order, orderBy, onRequestSort } : { order: 'asc' | 'desc', orderBy: string, onRequestSort: (property: string, tipo: string) => void }) => {
    const { clientiData, isLoadingAll } = useAllClientFileCounts(clienti_invitati);

    const headers = [
      ...((tipo_Account === 'amministratore' || tipo_Account === 'azienda') ? [{ label: '', id:'', sortable:false}] : []),
      { label: 'Email', id: 'email', sortable: true },
      { label: 'Ultima Attività', id: 'statistiche_utente.ultimoAccessoTimestamp', sortable: true },
      { label: 'File caricati', id: 'file_caricati_count', sortable: true },
      { label: 'XML completati', id: 'xml_completati_count', sortable: true },
      { label: 'Scarica i PDF', id: 'pdf_scaricabili_count', sortable: true },
      { label: 'Stato Invito', id: 'statoInvito', sortable: false },
    ];

    // Funzione per l'handler di ordinamento
    const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(property, 'cliente');
    };

    // Applicare l'Ordinamento
    const sortedClients = useMemo(() => {
      if (tipofiltro == 'cliente' || tipofiltro == ''){
        if ( isLoadingAll || clienti_invitati.length === 0 ) return [];
        let filteredUsers = clientiData || [];
        filteredUsers = applyAllFilters(filteredUsers, currentFilters);
        
        return sortArray(filteredUsers, order, orderBy);
      } else {
        if ( isLoadingAll || clienti_invitati.length === 0 ) return [];
          return sortArray(clientiData, order, orderBy);
      }
    }, [clienti_invitati, tipofiltro, currentFilters, isLoadingAll]);

    //evitiamo flickering
    const [LastSortedClients, setLastSortedClients] = useState<any[]>([]);
    useEffect(()=>{
      if (sortedClients.length > 0) {
        setLastSortedClients(sortedClients);
    }
    }, [sortedClients])

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 1rem 1rem 0' }}>
              <Typography variant="h6">
                Clienti invitati 
                {Object.keys(currentFilters).length > 0 ? (
                  tipofiltro == 'cliente'?
                  <IconButton   
                    onClick={handleClearFilters}
                    sx={{ml:'10px', width:'1.7rem', height:'1.7rem'}} 
                    color="primary" 
                    title="Rimuovi Filtro"
                  >
                    <SortIcon sx={{ width:'1.3rem', height:'1.3rem'}}/>
                  </IconButton>
                  : 
                  <IconButton   
                    onClick={()=>{setTipofiltro('cliente'); handleClearFilters(); handleOpenFilterDialog()}}
                    sx={{ml:'10px', width:'1.7rem', height:'1.7rem'}} 
                    color="default"
                    title="Filtra"
                  >
                    <FilterListIcon sx={{ width:'1.3rem', height:'1.3rem'}}/>
                  </IconButton>
                ):(
                  <IconButton   
                    onClick={()=>{setTipofiltro('cliente'); handleOpenFilterDialog()}}
                    sx={{ml:'10px', width:'1.7rem', height:'1.7rem'}} 
                    color="default"
                    title="Filtra"
                  >
                    <FilterListIcon sx={{ width:'1.3rem', height:'1.3rem'}}/>
                  </IconButton>
                )}
              </Typography>
                {(tipo_Account === 'amministratore' || tipo_Account === 'azienda') ? (
                  <Button
                    variant='outlined'
                    title="Seleziona uno o più clienti"
                    disabled={selectedClienti.length === 0}
                    onClick={() => setShareModalOpen(true)}
                    startIcon={<GroupAdd />}
                  >
                     Condividi con
                  </Button> )
                  : <></>
                }
            </div>
            <TableContainer component={Paper} sx={{ maxHeight: '25rem' }}>
                <Table size="small" stickyHeader>
                    <TableHead>
                        <TableRow>
                            {headers.map((head) => (
                                <TableCell
                                    key={head.id}
                                    sortDirection={orderBy === head.id ? order : false}
                                    sx={{ cursor: head.sortable ? 'pointer' : 'default' }}
                                    onClick={head.sortable ? createSortHandler(head.id) : undefined}
                                >
                                    <Stack direction="row" spacing={0} alignItems="center">
                                        <Typography variant="body2" component="span">
                                            {head.label}
                                        </Typography>
                                        {head.sortable && (
                                            <IconButton
                                                size="small"
                                                title={order === 'asc' ? `Ordine Decrescente` : `Ordine Crescente`}
                                                sx={{
                                                    ml: '5px',
                                                    padding: 0.5,
                                                    width: '1.7rem'
                                                }}
                                            >
                                                <ImportExportOutlined sx={{ height: '1.2rem' }} />
                                            </IconButton>
                                        )}
                                    </Stack>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(() => {
                            const invitedClientRows: any = [];

                            // Righe Inviti in Sospeso
                            if (inviti_emessi) {
                                Object.entries(inviti_emessi).forEach(([k, v]) => {
                                    if (v.tipo === 'cliente') {
                                        invitedClientRows.push(
                                            <TableRow key={`invite-${k}`}>
                                                {(tipo_Account === 'amministratore' || tipo_Account === 'azienda') ? <TableCell padding="checkbox"></TableCell> : <></>}
                                                <TableCell sx={{ padding: '0px 16px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: '100%', minHeight: '30px' }}>
                                                        {v.email}
                                                    </div>
                                                </TableCell>
                                                <TableCell>—</TableCell>
                                                <TableCell>—</TableCell>
                                                <TableCell>—</TableCell>
                                                <TableCell>—</TableCell>
                                                <TableCell>{v.stato ? <Chip {...statoChipPropsStatoI(v.stato)} /> : "—"}</TableCell>
                                            </TableRow>
                                        );
                                    }
                                });
                            }
                            //Righe Clienti Attivi
                            if (LastSortedClients) {
                                LastSortedClients.forEach((v: any) => { 
                                  invitedClientRows.push(
                                    <TableRow key={`active-${v.uid}`}>
                                      {(tipo_Account === 'amministratore' || tipo_Account === 'azienda') ? (
                                        <TableCell padding="checkbox">
                                          <Checkbox
                                            checked={selectedClienti.includes(v.uid)}
                                            onChange={() => toggleCliente(v.uid)}
                                          />
                                        </TableCell>
                                      ): <></>}
                                      <TableCell sx={{ padding: '0px 16px' }}>
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: '100%', minHeight: '30px' }}>
                                          <Avatar
                                            src={v.userPhotoURL || ""}
                                            sx={{ maxWidth: '30px', maxHeight: '30px', marginRight: '0.7rem' }}
                                          />
                                          {v.email}
                                        </div>
                                      </TableCell>
                                      <TableCell>
                                        {v.statistiche_utente?.ultimoAccessoTimestamp === 'online' ? ( 
                                          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                            <div style={{ display: 'flex', backgroundColor: 'green', borderRadius: '50%', width: '20px', height: '20px', marginRight: '6px' }} />
                                            online
                                          </div>
                                        ) : (
                                          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                            <div style={{ display: 'flex', backgroundColor: '#cf2020ff', borderRadius: '50%', width: '20px', height: '20px', marginRight: '6px' }} />
                                            {(v.statistiche_utente?.ultimoAccessoTimestamp && new Date(v.statistiche_utente.ultimoAccessoTimestamp).toLocaleString()).slice(0, 17) || 'Invalid Date'}
                                          </div>
                                        )}
                                      </TableCell>
                                      <TableCell>{v.file_cliente ? v.file_cliente.length : 0}</TableCell>
                                      <FileElaboratiCell uidCliente={v.uid} /> 
                                      <FileInviatiCell uidCliente={v.uid} /> 
                                      <TableCell>{v.statoInvito ? <Chip {...statoChipPropsStatoI(v.statoInvito)} /> : "—"}</TableCell>
                                    </TableRow>
                                  )
                                })
                              }

                            if (LastSortedClients.length === 0 || !invitedClientRows || invitedClientRows.length === 0) {
                                return (
                                    <TableRow>
                                        <TableCell
                                            colSpan={tipo_Account == 'collaboratore'? 6 : 7}
                                            sx={{ textAlign: 'center', fontSize: '17px', color: 'gray', minHeight: '42px' }}
                                        >
                                            Nessun account cliente trovato.
                                        </TableCell>
                                    </TableRow>
                                );
                            }
                            return invitedClientRows;
                        })()}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}


// Sottoviste per ruolo 
  //amministratore
  const VistaAdmin = () => {

    return (
      <Stack spacing={2}>
         <Stack direction="row" spacing={1}>
          <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={() => {
                setInvitoTipo("azienda");
                setInviteDialogOpen(true);
              }}
            >
              Invita Azienda
            </Button>
            <Button 
              variant="outlined" 
              startIcon={<AddIcon />} 
              onClick={() => {
                setInvitoTipo("collaboratore"); 
                setInviteDialogOpen(true)
              }}
            >
              Invita Collaboratore
            </Button>
            <Button
              variant="contained"
              startIcon={<SendIcon />}
              onClick={() => {
                setInvitoTipo("cliente");
                setInviteDialogOpen(true);
              }}
            >
              Invita Cliente
            </Button>
          </Stack>
        <Typography variant="h6">Statistiche</Typography>
        <Grid container spacing={2}>
          <div>
            <StatisticaCard icon={<PeopleIcon />} title="Totale Account Registrati" value={TotUtenti} />
          </div>
          <div>
            <StatisticaCard
              icon={<DescriptionIcon />}
              title="Totale File Caricati"
              value={totFile}
            />
          </div>
          <div>
            <StatisticaCard
              icon={<DescriptionIcon />}
              title="Statistiche di gradimento"
              value={"es. inviti rifiutati, richieste di assistenza..."}
            />
          </div>
        </Grid>

        <Divider sx={{ my: 1 }} />

        <Typography variant="h6">
          Elenco Account
          {Object.keys(currentFilters).length > 0 ? (
            tipofiltro == 'amministratore' ?
            <IconButton   
              onClick={handleClearFilters}
              sx={{ml:'10px', width:'1.7rem', height:'1.7rem'}} 
              title="Rimuovi Filtro"
              color="primary" 
            >
             <SortIcon sx={{ width:'1.3rem', height:'1.3rem'}}/>
            </IconButton>
            : 
             <IconButton   
              onClick={()=>{setTipofiltro('amministratore'); handleClearFilters(); handleOpenFilterDialog()}}
              sx={{ml:'10px', width:'1.7rem', height:'1.7rem'}} 
              title="Filtra"
              color="default"
            >
             <FilterListIcon sx={{ width:'1.3rem', height:'1.3rem'}}/>
            </IconButton>
          ):(
            <IconButton   
              onClick={()=>{setTipofiltro('amministratore'); handleOpenFilterDialog()}}
              sx={{ml:'10px', width:'1.7rem', height:'1.7rem'}} 
              title="Filtra"
              color="default"
            >
             <FilterListIcon sx={{ width:'1.3rem', height:'1.3rem'}}/>
            </IconButton>
          )}
        </Typography>
        <TableContainer component={Paper} sx={{ maxHeight: '25rem' }}>
          <Table size="small" aria-label="table-account" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell><div style={{display:'flex', alignItems:'center'}}>Email<IconButton title={ order === 'asc' ? `Ordine Decrescente` : `Ordine Crescente`} onClick={()=>{handleRequestSort('email')}} sx={{ml:'5px', p:0.5}}><ImportExportOutlined sx={{height:'1.2rem', width:'1.3rem'}}/></IconButton></div></TableCell>
                <TableCell><div style={{display:'flex', alignItems:'center'}}>Tipo Account<IconButton title={ order === 'asc' ? `Ordine Decrescente` : `Ordine Crescente`} onClick={()=>{handleRequestSort('tipo_account')}} sx={{ml:'5px', p:0.5}}><ImportExportOutlined sx={{height:'1.2rem', width:'1.3rem'}}/></IconButton></div></TableCell>
                <TableCell><div style={{display:'flex', alignItems:'center'}}>Data di Registrazione<IconButton title={ order === 'asc' ? `Ordine Decrescente` : `Ordine Crescente`} onClick={()=>{handleRequestSort('data_registrazione')}} sx={{ml:'5px', p:0.5}}><ImportExportOutlined sx={{height:'1.2rem', width:'1.3rem'}}/></IconButton></div></TableCell>
                <TableCell><div style={{display:'flex', alignItems:'center'}}>Ultima Attività<IconButton title={ order === 'asc' ? `Ordine Decrescente` : `Ordine Crescente`} onClick={()=>{handleRequestSort('ultimoAccessoTimestamp')}} sx={{ml:'5px', p:0.5}}><ImportExportOutlined sx={{height:'1.2rem', width:'1.3rem'}}/></IconButton></div></TableCell>
                <TableCell><div style={{display:'flex', alignItems:'center'}}>Statistiche Uso<IconButton title={ order === 'asc' ? `Ordine Decrescente` : `Ordine Crescente`} onClick={()=>{handleRequestSort('fileCaricati')}} sx={{ml:'5px', p:0.5}}><ImportExportOutlined sx={{height:'1.2rem', width:'1.3rem'}}/></IconButton></div></TableCell>
                <TableCell><div style={{display:'flex', alignItems:'center'}}>File Rielaborati+<IconButton title={ order === 'asc' ? `Ordine Decrescente` : `Ordine Crescente`} onClick={()=>{handleRequestSort('fileRielaborati')}} sx={{ml:'5px', p:0.5}}><ImportExportOutlined sx={{height:'1.2rem', width:'1.3rem'}}/></IconButton></div> </TableCell>
                <TableCell>Stato Invito</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!sortedUsers || sortedUsers.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7} sx={{ textAlign: 'center', fontSize: '17px', color:'gray', minHeight: '42px' }}>
                    Nessun account trovato.
                  </TableCell>
                </TableRow>
              )}
              {sortedUsers?.map((u) => (
                <TableRow key={u.email}>
                  <TableCell>
                    <div style={{ display:'flex', flexDirection:'row', alignItems: 'center', height: '100%', minHeight: '30px' }}>
                      <Avatar 
                        src={u.userPhotoURL || ""} 
                        sx={{ maxWidth: '30px', maxHeight: '30px', marginRight: '0.7rem' }}
                      /> 
                      {u.email}
                    </div>
                  </TableCell>
                  <TableCell>{u.tipo_account ? <Chip {...statoChipPropsTipoAcc(u.tipo_account)} size="small" /> : "—"}</TableCell>
                  <TableCell>{u.data_registrazione.slice(0,17)}</TableCell>
                  <TableCell>
                    { u.ultimoAccessoTimestamp == '' ? 'Invalid Date' : u.ultimoAccessoTimestamp == 'online'
                      ? <div style={{display:'flex', justifyContent:'flex-start'}}><div style={{ display: 'flex', backgroundColor:'green', borderRadius:'50%', width:'19px', marginRight:'6px', maxHeight: '19px'}}/> online </div>
                      : <div style={{display:'flex', justifyContent:'flex-start'}}><div style={{ display: 'flex', backgroundColor:'#cf2020ff', borderRadius:'50%', width:'19px', marginRight:'6px', maxHeight: '19px'}}/>{u.ultimoAccessoTimestamp.slice(0,17)}</div>
                    }
                  </TableCell>
                  <TableCell>
                    {u.tipo_account == 'cliente'? `File caricati: ${u.fileCliente || 0}`: `File: ${u.fileCaricati || 0} — Tempo: ${formatTime(u.tempoUtilizzoSecondi || 0)}`}
                  </TableCell>
                  <TableCell>{u.tipo_account == 'cliente'? '—' : u.fileRielaborati}</TableCell>
                  <TableCell>
                    {u.statoInvito ? <Chip {...statoChipPropsStatoI(u.statoInvito)} size="small" /> : "—"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Divider sx={{ my: 1 }} />

        <TabInvitatiAC tipo ='azienda' map_invitati = {aziende_invitate} order={aziendeOrder} orderBy={aziendeOrderBy} onRequestSort={handleRequestInviteSort}/>

        <Divider sx={{ my: 1 }} />

        <TabInvitatiAC tipo ='collaboratore' map_invitati = {collaboratori_invitati} order={collOrder} orderBy={collOrderBy} onRequestSort={handleRequestInviteSort}/>

         <Divider sx={{ my: 1 }} />

        <TabInvitatiClienti order={clientiOrder} orderBy={clientiOrderBy} onRequestSort={handleRequestInviteSort}/>

      </Stack>
    );
  };

  // azienda
  const VistaAzienda = () => {

    return (
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
          <Typography variant="h6">Panoramica</Typography>
          <Stack direction="row" spacing={1}>
            <Button 
              variant="outlined" 
              startIcon={<AddIcon />} 
              onClick={() => {
                setInvitoTipo("collaboratore"); 
                setInviteDialogOpen(true)
              }}
            >
              Invita Collaboratore
            </Button>
            <Button
              variant="contained"
              startIcon={<SendIcon />}
              onClick={() => {
                setInvitoTipo("cliente");
                setInviteDialogOpen(true);
              }}
            >
              Invita Cliente
            </Button>
          </Stack>
        </Stack>

        <Grid container spacing={2}>
          <div>
            <StatisticaCard icon={<PeopleIcon />} title="Totale Files Elaborati" value={totaleFileTeam} />
          </div>
          <div>
            <StatisticaCard icon={<AttachFileIcon />} title="Tu: File caricati" value={statisticheUtente.fileCaricati} />
          </div>
          <div>
            <StatisticaCard
              icon={<PersonIcon />}
              title="Tu: Tempo Utilizzo"
              value= {formatTime(statisticheUtente.tempoUtilizzoSecondi ?? 0)}
            />
          </div>
        </Grid>

        <Divider sx={{ my: 1 }} />

        <TabInvitatiAC tipo ='collaboratore' map_invitati = {collaboratori_invitati} order={collOrder} orderBy={collOrderBy} onRequestSort={handleRequestInviteSort}/>

        <Divider sx={{ my: 1 }} />

        <TabInvitatiClienti order={clientiOrder} orderBy={clientiOrderBy} onRequestSort={handleRequestInviteSort}/>

      </Stack>
    );
  };

  //collaboratore
  const VistaCollaboratore = () => {
    return (
      <Stack spacing={2}>
        {invitatoDaUID && (
          <Alert severity="info">
            Collaboratore di : <strong>{invitatoDaUID}</strong>
          </Alert>
        )}

        <Typography variant="h6">Le tue statistiche</Typography>
        <Grid container spacing={2}>
          <div> 
            <StatisticaCard icon={<DescriptionIcon />} title="File Caricati" value={statisticheUtente.fileCaricati} />
          </div>
          <div>
            <StatisticaCard
              icon={<AccessTime />}
              title="Tempo Utilizzo"
              value={formatTime(statisticheUtente.tempoUtilizzoSecondi ?? 0)}
            />
          </div>
        </Grid>

        <Stack direction="row" spacing={1} alignItems="center">
          <Button variant="contained" startIcon={<SendIcon />} onClick={() => { setInvitoTipo("cliente"); setInviteDialogOpen(true); }}>
            Invita Cliente
          </Button>
        </Stack>

        <Divider sx={{ my: 1 }} />

        <TabInvitatiClienti order={clientiOrder} orderBy={clientiOrderBy} onRequestSort={handleRequestInviteSort}/>

      </Stack>
    );
  };

  // cliente
  const VistaCliente = () => {
    return (
      <Stack spacing={2}>
        {invitatoDaUID && (
          <Alert severity="info">
            Cliente di : <strong>{invitatoDaUID}</strong>
          </Alert>
        )}

        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">I tuoi documenti</Typography>
          <div style={{display:'flex', justifyContent:'flex-end'}}>
            <Button variant="contained" startIcon={<AddIcon />} onClick={() => setAddRecordOpen(true)}>
              Aggiungi Fatture in PDF
            </Button>
            {selectedDeleteCount > 0 && (
              <Button 
                variant="outlined" 
                color="error" 
                startIcon={<Trash2Icon style={{maxHeight:'1.3rem'}}/>} 
                onClick={() => setDeliteFileModal(true)} 
                sx={{ml:'1rem', fontWeight:600}}
              >
                Elimina ({selectedDeleteCount})
              </Button>
            )}
          </div>
        </Stack>
        <TableContainer component={Paper}  sx={{ maxHeight: '30rem' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>File</TableCell>
                <TableCell>Caricato</TableCell>
                <TableCell>Stato</TableCell>
                <TableCell>XML elaborato da</TableCell>
                <TableCell padding="checkbox" >
                  <div style={{ display:'flex', flexDirection:'row', alignItems:'center'}}>
                    Seleziona 
                    <Checkbox 
                      indeterminate={indeterminateForDelete}
                      checked={selectAllForDelete}
                      onChange={handleSelectAllDelete}
                      inputProps={{ 'aria-label': 'seleziona tutti i file' }}
                    />
                  </div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fileCliente && fileCliente.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} sx={{ textAlign: 'center', fontSize: '17px', color:'gray', minHeight: '42px'}}>
                    Nessun documento caricato.
                  </TableCell>
                </TableRow>
              )}
              {fileCliente && fileCliente.length > 0 && fileCliente.map((f, idx) => (
                <TableRow key={idx}>
                  <TableCell sx={{display:'flex', flexDirection:'row',alignItems: 'center'}}><Avatar sx={{ maxWidth:'30px', maxHeight:'30px', marginRight: '0.7rem' }}><DescriptionIcon style={{maxHeight:'1.3rem'}}/></Avatar> {f.nome}</TableCell>
                  <TableCell>
                    {(new Date(f.timestampCaricamento).toLocaleString()).slice(0,17)}
                  </TableCell>
                  <TableCell><Chip {...statoChipPropsStatoI(f.stato)} size="small" /></TableCell>
                  <TableCell>
                    <div style={{ display:'flex', flexDirection:'row', alignItems: 'center', height: '100%', minHeight: '30px' }}>
                      <Avatar 
                        src={f.xmlElaboratiDa && typeof f.xmlElaboratiDa !== 'string' ? f.xmlElaboratiDa.userPhotoURL : ""} 
                        sx={{ maxWidth: '30px', maxHeight: '30px', marginRight: '0.7rem' }}
                      /> 
                      {f.xmlElaboratiDa && typeof f.xmlElaboratiDa !== 'string' ? f.xmlElaboratiDa.email : '—'}
                    </div>
                  </TableCell>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={filesToDelete.includes(f.nome)}
                      onChange={() => handleToggleDelete(f.nome)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    );
  };

  
  // Render Principale
  if (isLoading) {
    return (
      <Box
        sx={{
          height: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Paper sx={{ p: 2, mb: 3 }}>
          <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
            <div style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
              <div style={{margin:'0 2rem 0 1rem'}}>
                <Avatar sx={{ width: 84, height: 84 }} src={ userPhotoURL ? userPhotoURL : ""} />
              </div>
              <div>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Box>
                    <Typography variant="h6">{ragioneSociale || "Utente"}</Typography>
                    <Typography variant="body2" color="textSecondary">
                      {email || "Email non disponibile"} — <strong>{ruoloDisplay}</strong>
                    </Typography>
                  </Box>
                  
                </Stack>

                {tipo_Account == 'collaboratore' ? <Stack></Stack>: 
                <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mt: 2 }}>
                  <Box>
                    <Typography variant="caption" color="textSecondary">
                      Partita IVA
                    </Typography>
                    <Typography variant="body2">{partitaIva || "-"}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="textSecondary">
                      Indirizzo
                    </Typography>
                    <Typography variant="body2">
                      {indirizzo ? `${indirizzo}, ${cap} ${comune} , ${nazione}` : "-"}
                    </Typography>
                  </Box>
                </Stack>}
              </div>
              <div style={{display:'flex', height:'100%', alignItems:'flex-start'}}>
                <Box sx={{ml:'1rem'}}>
                  <IconButton onClick={() => setEditOpen(true)} title="Modifica profilo">
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => setOptionModal(true)} sx={{ml:'1rem'}} title="Opzioni di formattazione dei dati">
                    <ManageAccounts/>
                  </IconButton>    
                </Box>
              </div>
            </div>
            <div>
              <Button 
                variant="contained" color='error' 
                onClick={()=>{ setShowLogoutModal(true) }}
              >
                <Logout sx={{mr:'0.7rem'}}/>
                Logout
              </Button>
            </div>
          </div>
      </Paper>

      {/* ---------- Sezione Statistiche Dinamiche (Switch in base a tipo_account) ---------- */}
      <Box>
        {tipo_Account === "amministratore" && <VistaAdmin />}
        {tipo_Account === "azienda" && <VistaAzienda />}
        {tipo_Account === "collaboratore" && <VistaCollaboratore />}
        {tipo_Account === "cliente" && <VistaCliente />}

        {/* Caso fallback */}
        {!["amministratore", "azienda", "collaboratore", "cliente"].includes(tipo_Account) && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            Tipo account non riconosciuto ({tipo_Account}).
          </Alert>
        )}
      </Box>
      <div style={{margin:'4rem 0 4rem 0'}}>
        {tipo_Account == 'cliente' ? <></> : 
          <Button 
            variant="contained" color='error'
            onClick={()=>{ navigate("/")}}
          >
            <ArrowBack sx={{mr:'1rem'}}/> 
            INDIETRO
          </Button>
        }
      </div>

      {/* ---------- Modali ---------- */}
      {showLogoutModal && <ShowLogout setShowLogoutModal={setShowLogoutModal} classNameButton="button-style" />}
      {/* ---------- Opzioni ---------- */}
      {optionModal && (
        <div className="overlayer3" style ={{backgroundColor: 'rgba(0, 0, 0, 0.47)'}}>
          <div style={{borderRadius: '6px', backgroundColor:'#fff', padding:'0 0 2rem 2rem', border: '0'}}>
            <div style={{display:'flex', justifyContent:'flex-end'}}>
              <button  className="X2close" style={{borderTopRightRadius:'6px'}} onClick={()=> setOptionModal(false)}>✕</button>
            </div>
            <Box sx={{ maxWidth: 400, paddingRight:'2rem'}}>
                <h2> <SettingsOutlined/> Opzioni di Conversione Dati</h2>
                <p style={{fontSize: '0.9rem', margin: '1rem 0 1rem 0', lineHeight: '1.4', padding:'0.7rem', border:'1px solid #ccc', borderRadius:'6px', backgroundColor:'#f0eeeeff'}}>
                  Questi parametri sono stati pre-selezionati per <strong>semplificare</strong> la registrazione delle fatture estere in specifici canali che potrebbero <strong>non accettare</strong> i valori originali (es. caratteri speciali, lunghezze eccessive).
                  <br/>
                  Se si desidera <strong>mantenere i dati originali</strong> della fattura, attivare la rispettiva opzione di seguito.
                </p>
                <List>
                  {Object.keys(optionsState).sort().map((key, index) => (
                  <React.Fragment key={key}>
                    <ListItem>
                      <ListItemText 
                        id={`switch-list-label-${key}`} 
                        primary={optionLabels[key as OptionKey]} 
                      /> 
                      <Switch
                          sx={{marginLeft:'2rem'}}
                          edge="end"
                          checked={optionsState[key as OptionKey]}
                          onChange={handleToggleOption(key as OptionKey)}
                          inputProps={{ 'aria-labelledby': `switch-list-label-${key}` }}
                          color="primary"
                        />
                    </ListItem>
                    {/* divisore tra ogni elemento */}
                    {index < Object.keys(optionsState).length - 1 && <Divider />}
                  </React.Fragment>
                ))}
              </List>
            </Box>
          </div>
        </div>
      )}
      {/* Modale modifica Profilo*/}
      <Dialog open={editOpen} onClose={() => setEditOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Modifica Profilo <Divider sx={{mt:'1rem', backgroundColor:'#d1d1d1ff'}}/> </DialogTitle>
        <div style={{padding:'1rem 3rem'}}>
          <FormWithEntry 
            firstTime = {false}
            loading = {loading}
            tipoAccount = {tipo_Account}
            onDataSubmit = {handleSubmit}
            emailInvitante = {null}
            partitaIva = {partitaIva}
            RSociale = {ragioneSociale}
            address = {indirizzo}
            CAP = {cap}
            city = {comune}
            initialCountry = {nazione}
            onClose = {() => setEditOpen(false)}
          />
        </div>
      </Dialog>

      {/* ----------------- Dialog Invito ----------------- */}
      <Dialog open={inviteDialogOpen} onClose={() => setInviteDialogOpen(false)}>
        <DialogTitle>Invia un invito per utilizzale<br/>la piattaforma a un <strong>{invitoTipo}</strong>.</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1, minWidth: 360 }}>
            <TextField
              label="Email"
              value={invitoEmail}
              onChange={(e) => setInvitoEmail(e.target.value)}
              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px', justifyContent: 'space-between' }}>
          <Button onClick={() => {setInvitoEmail(''); setInviteDialogOpen(false)}}>Annulla</Button>
          <Button variant="contained" onClick={() =>{ handleInviaInvito(); setInviteDialogOpen(false); setInvitoEmail("") }}>
            Invia
          </Button>
        </DialogActions>
      </Dialog>

      {/* ----------------- Dialog Download ----------------- */}
      <Dialog open={downloadModal} onClose={() => {}}>
        <div style={{padding:'1rem 2rem 1rem 2rem'}}>
        <DialogTitle>
          File in attesa di elaborazione e download 
          <button className="Xclose" onClick={handleClose} style={{position:"absolute", top:0 , right:0}}>✕</button>
        </DialogTitle>
        <Divider sx={{ my: 1 }} />
        <DialogContent sx={{ padding: '24px' }}>
          <Stack spacing={2} sx={{ minWidth: 360 }}>
      
          <Typography variant="body2" color="text.secondary">
            Scegli i file che desideri scaricare. Puoi effettuare il download singolo o selezionarne più di uno.
          </Typography>
      
          <Box sx={{ maxHeight: 300, overflowY: 'auto' }}>
            {isLoadingCF && <ListItem sx={{ display:'flex', justifyContent:'center', fontSize:'25px', color:'#1e75d8ff', fontWeight:600 }}> Caricamento... </ListItem> }
            {files.Elaborato && Object.keys(files.Elaborato).length > 0 && (
              <>
                <Divider sx={{ my: 0 }} /> 
                <ListItemButton 
                  onClick={handleToggleElaborati} 
                  sx={{ 
                    fontWeight: 'bold', 
                    backgroundColor: elaboratiOpen ? 'action.selected' : 'inherit',
                  }}
                >
                  <ListItemIcon>
                    {elaboratiOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItemIcon>
                  <ListItemText primary={`File Elaborati (${Object.keys(files.Elaborato).length})`} />
                </ListItemButton>
              </>
            )}

            {/* Lista dei File Elaborati - Nascosta/Mostrata */}
            <Collapse in={elaboratiOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {files.Elaborato && Object.entries(files.Elaborato).map(([k, v]) => (
                  <ListItem
                    key={`elaborato-${k}`}
                    secondaryAction={
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Checkbox 
                          edge="end" 
                          checked={selectedFileNames.includes(v.nome)} 
                          onChange={() => handleToggle(v.nome)} 
                          inputProps={{ 'aria-labelledby': `checkbox-list-label-${v.nome}` }}
                        />
                      </Stack>
                    }
                    disablePadding
                    sx={{ '&:hover': { backgroundColor: 'action.hover' } }}
                  >
                    <ListItemButton role={undefined} dense onClick={() => handleToggle(v.nome)} sx={{ pl: 4 }}> 
                      <ListItemIcon>
                        { v.nome  && <PictureAsPdfIcon color="error"/>} 
                      </ListItemIcon>
                      <ListItemText
                        id={`checkbox-list-label-${v.nome}`}
                        primary={v.nome}
                      />
                      {v.stato === 'Elaborato'? <div style={{marginRight:'1rem', backgroundColor:'#1c921cff', borderRadius:'50%', width:'15px', height:'15px'}} title={v.stato}/> : <div style={{marginRight:'1rem', backgroundColor:'#f78629ff', borderRadius:'50%', width:'15px', height:'15px'}} title={v.stato}/>}
                      <div style={{ display:'flex', flexDirection:'row', alignItems: 'center', height: '100%', minHeight: '30px', marginRight:'1rem' }} title={v.xmlElaboratiDa && typeof v.xmlElaboratiDa !== 'string' ? v.xmlElaboratiDa.email : ""}>
                        <Avatar 
                          src={v.xmlElaboratiDa && typeof v.xmlElaboratiDa !== 'string' ? v.xmlElaboratiDa.userPhotoURL : ""} 
                          sx={{ maxWidth: '30px', maxHeight: '30px', marginRight: '0.7rem' }}
                        /> 
                      </div>
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </Box>

          <List 
            component="nav" 
            sx={{ 
              border: '1px solid #e0e0e0', 
              borderRadius: '8px',
              padding: 0  
            }}
          >
        
        <ListItem 
          secondaryAction={
            <Checkbox
              edge="end"
              checked={selectAll}
              onChange={handleSelectAll} 
              indeterminate={indeterminate} 
            />
          }
          sx={{ 
            backgroundColor: 'action.hover',
            borderBottom: '1px solid #e0e0e0',
            fontWeight: 'bold'
          }}
        >
          <ListItemText primary="Seleziona tutti i file" />
        </ListItem>

        {/* Lista dei File */}
        <Box sx={{ maxHeight: 300, overflowY: 'auto' }}>
          {isLoadingCF && <ListItem sx={{ display:'flex', justifyContent:'center', fontSize:'25px', color:'#1e75d8ff', fontWeight:600 }}> Caricamento... </ListItem> }
          {Object.entries(files.Inviato).map(([k, v]) => (
            <ListItem
              key={k}
              secondaryAction={
                <Stack direction="row" spacing={1} alignItems="center">
                  
                  <Checkbox 
                    edge="end" 
                    checked={selectedFileNames.includes(v.nome)} 
                    onChange={() => handleToggle(v.nome)} 
                    inputProps={{ 'aria-labelledby': `checkbox-list-label-${v.nome}` }}
                  />
                </Stack>
              }
              disablePadding
              sx={{ '&:hover': { backgroundColor: 'action.hover' } }}
            >
              <ListItemButton role={undefined} dense onClick={() => handleToggle(v.nome)}>
                <ListItemIcon>
                  { v.nome  && <PictureAsPdfIcon color="error" />}
                </ListItemIcon>
                <ListItemText
                  id={`checkbox-list-label-${v.nome}`}
                  primary={v.nome}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </Box>
      </List>
      
      {/* Riepilogo Selezione */}
      <Box sx={{ p: 1, border: '1px dashed #ccc', borderRadius: '4px', textAlign: 'center' }}>
        <Typography variant="subtitle2">
          <strong style={{color:'#cf2121ff'}}>{totalFiles}</strong> <label style={{ marginRight:'2rem'}}>file disponibili.</label>
          <strong style={{color:'#cf2121ff'}}>{selectedCount}</strong> file selezionati.
        </Typography>
      </Box>

    </Stack>
  </DialogContent>

  <DialogActions sx={{ display:'flex', flexDirection:'column', padding: '16px 24px' }}>
    <div style={{display:'flex', justifyContent:'space-between', marginBottom:'1rem'}}>
      <Button 
        onClick={handleAddContexArray} 
        color="primary" 
        variant="contained" 
        startIcon={<Loop/>}
        disabled={selectedCount === 0} 
        sx={{mr:'2rem'}}
      >
        Elabora Selezionati
      </Button>
      <Button 
        onClick={ async() => {
          for (const fileName of selectedFileNames) {
            await aggiornaStatoFileCliente( clienteUid, fileName, String(userId), 'Scaricato')
          }; 
          handleMultipleDownload() 
        }} 
        color="primary" 
        variant="contained" 
        startIcon={<DownloadIcon />}
        disabled={selectedCount === 0} 
      >
        Scarica Selezionati
      </Button>
    </div>
    <Button 
      onClick={()=>{ 
        handleMultipleDownload(); 
        handleAddContexArray() 
      }} 
      color="primary" 
      variant="outlined" 
      disabled={selectedCount === 0} 
      sx={{fontWeight:500}}
    >
      Scarica ed Elabora Selezionati
    </Button>
    
  </DialogActions>
  </div>
</Dialog>

      {/* ----------------- Dialog Aggiungi Record (Cliente) ----------------- */}
      <Dialog open={addRecordOpen} onClose={() => setAddRecordOpen(false)}>
        <DialogTitle>Aggiungi Fatture in PDF</DialogTitle>

        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>

            <Button
              variant="outlined"
              component="label"
            >
              Seleziona PDF
              <input
                type="file"
                accept="application/pdf"
                multiple
                hidden
                onChange={(e) => {
                  const files = e.target.files ? Array.from(e.target.files) : [];
                  setSelectedFiles(files);
                }}
              />
            </Button>

            {selectedFiles.length > 0 && (
              <ul style={{margin:'2rem 2rem 0 2rem', }}>
                {selectedFiles.map((file, i) => (
                  <li key={i}>{file.name}</li>
                ))}
              </ul>
            )}
          </Stack>
        </DialogContent>

        <DialogActions  sx={{ padding: '16px 24px', justifyContent: 'space-between' }}>
          <Button onClick={() => setAddRecordOpen(false)}>Annulla</Button>
          <Button variant="contained" onClick={handleAggiungiRecord}>
            Carica
          </Button>
        </DialogActions>
      </Dialog>
      {/* ----------------- Dialog Elimina Record (Cliente) ----------------- */}
      <Dialog
        open={deliteFileModal}
        onClose={() => setDeliteFileModal(false)}
        maxWidth="xs"  //
        fullWidth
        
      >
        <DialogTitle 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1, 
            color: 'error.main'
          }}
        >
          <Trash2Icon style={{ fontSize: 30 }} /> 
          Conferma Eliminazione
        </DialogTitle>

        <DialogContent sx={{padding:'2rem'}}> 
          <Divider sx={{ mb: 2 }} />
          <Stack spacing={2}>
            <Typography style={{display:'flex', alignItems:'center' }}>
              Stai per eliminare &nbsp; {filesToDelete.length > 1 ? <><strong>{filesToDelete.length}</strong>&nbsp; file</> : <>il file &nbsp;<strong>"{filesToDelete[0]}"</strong></>}
            </Typography>
      
            <Typography variant="subtitle1" color="error.main" sx={{display:'flex', alignItems:'center'}}>
              <AlertTriangle style={{ width:'3rem' }}/>
              <Typography sx={{ marginLeft:'1rem' }}>Attenzione: <strong>Questa azione è irreversibile</strong> e i dati saranno persi definitivamente.</Typography>
            </Typography>
            {filesToDelete.length > 1 && (
              <>
                <Typography variant="caption" color="text.secondary">
                  File coinvolti:
                </Typography>
                <Box 
                  sx={{ 
                    maxHeight: 100, 
                    overflowY: 'auto', 
                    border: '1px solid', 
                    borderColor: 'divider', 
                    borderRadius: 1, 
                    p: 1 
                  }}
                >
                  {filesToDelete.map((fileName) => (
                    <Typography key={fileName} variant="caption" display="block" sx={{ ml: 1 }}>
                      • {fileName}
                    </Typography>
                  ))}
                </Box>
              </>
            )}
          </Stack>
        </DialogContent>

        <DialogActions sx={{ padding: '16px 24px', justifyContent: 'space-between' }}> 
          <Button 
          variant="outlined"
            onClick={() => {
              setDeliteFileModal(false);
              setFilesToDelete([]); 
            }} 
          >
            Annulla
          </Button>
          <Button 
            variant="contained" 
            onClick={handleEliminaRecord} 
            color="error" 
            startIcon={<Trash2Icon style={{maxHeight:'1.2rem'}} />}
          >
            Elimina 
          </Button>
        </DialogActions>
      </Dialog>
      {/*---------- Condivisione Cliente ----------*/}
      <Dialog open={shareModalOpen} onClose={() => setShareModalOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Condividi cliente</DialogTitle>
        <DialogContent>
          <Typography sx={{ ml: 1, mb: 2 }}>
            Seleziona i collaboratori con cui vuoi condividere <br/>{selectedClienti.length} {selectedClienti.length === 1 ? 'cliente' : 'clienti'} :
          </Typography>
          <Divider sx={{m:'1rem'}}/>
          <List>
            {collaboratori_invitati.length === 0 ? 
              <Typography sx={{display:'flex', color:'#818181ff', textAlign:'center', padding:'1rem 3rem 0 3rem', userSelect:'none'}}>Nessun collaboratore con cui condividere la gestione dei clienti. </Typography>:
              collaboratori_invitati.map(coll => (
              <ListItem key={coll.uid} onClick={() => toggleCollaboratore(coll.uid)}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: '100%', minHeight: '30px', marginRight:'1rem' }}>
                  <Avatar src={coll.userPhotoURL} />
                </div>
                <ListItemText primary={coll.email} />
                <Checkbox checked={selectedCollaboratori.includes(coll.uid)} />
              </ListItem>
            ))}
          </List>
        </DialogContent>

        <DialogActions sx={{ padding: '16px 24px', justifyContent: 'space-between' }}>
          <Button onClick={() => {setSelectedClienti([]); setShareModalOpen(false)}}>Annulla</Button>
          <Button
            variant="contained"
            disabled={selectedCollaboratori.length === 0}
            onClick={handleCondivisione}
          >
            Condividi
          </Button>
        </DialogActions>
      </Dialog>
      {/*---------- Visualizza Clienti dei collaboratori ----------*/}
      <Dialog open={infoCilentiColl} onClose={() => setInfoCilentiColl(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          {!clientiCollaboratori[collaboratore] || clientiCollaboratori[collaboratore].length === 0 ? <div style={{padding:'2rem 0 0 1rem'}}><strong style={{margin:'0 0.5rem 0 0'}}>{emailcoll.slice(0, 1).toUpperCase()+emailcoll.slice(1)}</strong>non gestisce ancora nessun cliente.</div> : <div style={{padding:'1rem 0 0 0'}}>Clienti di <strong style={{margin:'0 0.5rem 0 0.2rem'}}>{emailcoll}</strong><Divider sx={{mt:'1rem'}}/></div> } 
          <button className="Xclose" onClick={() => setInfoCilentiColl(false)} style={{position:"absolute", top:0 , right:0}}>✕</button>
        </DialogTitle>
        <DialogContent>
          <List>
            {clientiCollaboratori[collaboratore]?.map(c => {
              const isInvitato = clienti_invitati?.some(
                (invitato) => invitato.uid === c.uid
              );

              return (
                <ListItem key={c.uid}>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: '100%', minHeight: '30px', marginRight:'1rem' }}>
                    <Avatar src={c.userPhotoURL} />
                  </div>
                  <ListItemText primary={c.email} /> 
                    {isInvitato && (
                      <IconButton 
                        onClick= {() => {setRimuoviCliente(c.uid); setEmailCli(c.email); setConfermaRimozione(true)} }
                        sx={{width:'35px', height:'35px', color:'#e42222ff', boxShadow:'2'}} 
                        title='Rimuovi Condivisione'
                      > 
                        <PersonRemove sx={{ padding:'1px'}}/> 
                      </IconButton>
                    )}
                </ListItem>
              );
            })}
          </List>
        </DialogContent>
      </Dialog>
      {/*---------- Conferma Rimozione ----------*/}
      <Dialog open={confermaRimozione} onClose={() => setConfermaRimozione(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Sei sicuro di voler rimuovere <strong>{emailCli}</strong> <br/> dai clienti gestiti da <strong>{emailcoll}</strong> ?</DialogTitle>
        <DialogActions sx={{ padding: '16px 24px', justifyContent: 'space-between' }}>
          <Button onClick={() => setConfermaRimozione(false)}>Annulla</Button>
          <Button
            variant="contained"
            onClick={() => {handleRimuoviCondivisione(); setConfermaRimozione(false)}}
          >
            Rimuovi
          </Button>
        </DialogActions>
      </Dialog>
      {/*---------- Filtro tabella ----------*/}
      <FilterDialog 
        tipo={tipofiltro}
        open={filterDialogOpen}
        onClose={handleCloseFilterDialog}
        currentFilters={currentFilters}
        onApplyFilters={handleApplyFilters}
        onClearFilters={handleClearFilters}
      />
    </Box>
  );
};

export default DashboardApp;

